<template>
  <van-popup
    v-model="showPopup"
    position="bottom"
    round
    :close-on-click-overlay="false"
    :style="{ height: '75%' }"
    @opened="onPopupOpened"
  >
    <div class="signature-popup">
      <div class="signature-header">
        <h3>签署确认</h3>
        <van-icon name="cross" @click="handleClose" />
      </div>

      <div class="signature-body">
        <div class="signature-target">
          <div class="target-label">当前签署</div>
          <div class="target-names">{{ agreementNames }}</div>
        </div>

        <div class="signature-canvas-wrap" ref="canvasWrap">
          <div class="canvas-tip">请在下方区域签名</div>
          <canvas
            ref="signCanvas"
            class="sign-canvas"
            @touchstart.prevent="onTouchStart"
            @touchmove.prevent="onTouchMove"
            @touchend="onTouchEnd"
            @mousedown.prevent="onMouseDown"
            @mousemove.prevent="onMouseMove"
            @mouseup="onMouseUp"
            @mouseleave="onMouseUp"
          ></canvas>
          <div class="canvas-actions">
            <van-button size="small" plain type="danger" @click="clearCanvas">清除重写</van-button>
          </div>
        </div>
      </div>

      <div class="signature-footer">
        <van-button
          block
          :loading="uploading"
          color="linear-gradient(to right, #5DD682, #5AFF8E)"
          @click="handleConfirm"
        >确认签署</van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Toast } from "vant";
import { uploadSign } from "@/utils/api/user";

export default {
  name: "SignaturePopup",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    agreements: {
      type: Array,
      default: () => []
    },
    activityId: {
      type: [String, Number],
      default: ""
    },
    babyId: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      showPopup: false,
      uploading: false,
      isDrawing: false,
      hasSigned: false,
      lastX: 0,
      lastY: 0,
      canvasW: 0,
      canvasH: 0,
      dpr: 1
    };
  },
  computed: {
    agreementNames() {
      return this.agreements.map((item) => item.title).join("、");
    },
    uploadType() {
      return this.agreements[0] ? this.agreements[0].type : "";
    }
  },
  watch: {
    value(val) {
      console.log("SignaturePopup value 变化:", val, "agreements:", JSON.stringify(this.agreements));
      this.showPopup = val;
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => this.initCanvas(), 100);
        });
      }
    },
    showPopup(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    onPopupOpened() {
      setTimeout(() => this.initCanvas(), 100);
    },
    initCanvas() {
      const canvas = this.$refs.signCanvas;
      const wrap = this.$refs.canvasWrap;
      if (!canvas || !wrap) return;

      // 获取容器实际可用宽度
      const wrapRect = wrap.getBoundingClientRect();
      const w = Math.max(wrapRect.width - 10, 200); // 减去 padding
      const h = 280;

      this.dpr = window.devicePixelRatio || 1;
      this.canvasW = w;
      this.canvasH = h;

      // 设置 canvas 物理像素尺寸（解决模糊）
      canvas.width = w * this.dpr;
      canvas.height = h * this.dpr;

      // 设置 canvas CSS 显示尺寸（保持不变）
      canvas.style.width = w + "px";
      canvas.style.height = h + "px";

      const ctx = canvas.getContext("2d");
      // 用 scale 让逻辑坐标 = CSS 僐素，之后绘制不用再乘 dpr
      ctx.scale(this.dpr, this.dpr);

      // 设置绘图样式（用 CSS 像素单位）
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      ctx.strokeStyle = "#222";
      ctx.lineWidth = 2.5;

      this.drawPlaceholder(ctx);
      this.isDrawing = false;
      this.hasSigned = false;
    },
    drawPlaceholder(ctx) {
      const w = this.canvasW;
      const h = this.canvasH;
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, w, h);
      ctx.strokeStyle = "#e6e6e6";
      ctx.lineWidth = 1;
      ctx.strokeRect(0.5, 0.5, w - 1, h - 1);
      ctx.fillStyle = "#c0c0c0";
      ctx.font = "15px PingFang SC, Microsoft YaHei, sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText("请在此处手写签名", w / 2, h / 2);
    },

    /**
     * 统一获取事件相对于 canvas 的 CSS 僐素坐标
     */
    getCanvasPos(e) {
      const canvas = this.$refs.signCanvas;
      if (!canvas) return { x: 0, y: 0 };

      const rect = canvas.getBoundingClientRect();

      let clientX, clientY;
      if (e.touches && e.touches.length > 0) {
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
      } else if (e.changedTouches && e.changedTouches.length > 0) {
        clientX = e.changedTouches[0].clientX;
        clientY = e.changedTouches[0].clientY;
      } else {
        clientX = e.clientX;
        clientY = e.clientY;
      }

      return {
        x: clientX - rect.left,
        y: clientY - rect.top
      };
    },

    startDraw(x, y) {
      this.isDrawing = true;
      this.lastX = x;
      this.lastY = y;

      // 画一个点（处理单击不滑动的情况）
      const canvas = this.$refs.signCanvas;
      const ctx = canvas.getContext("2d");
      // ctx.beginPath();
      // ctx.arc(x, y, 1.25, 0, Math.PI * 2);
      // ctx.fillStyle = "#222";
      // ctx.fill();
      this.hasSigned = true;
    },
    moveDraw(x, y) {
      if (!this.isDrawing) return;

      const canvas = this.$refs.signCanvas;
      const ctx = canvas.getContext("2d");

      ctx.beginPath();
      ctx.moveTo(this.lastX, this.lastY);
      ctx.lineTo(x, y);
      ctx.stroke();

      this.lastX = x;
      this.lastY = y;
      this.hasSigned = true;
    },
    endDraw() {
      this.isDrawing = false;
    },

    // ===== 触摸事件 =====
    onTouchStart(e) {
      const pos = this.getCanvasPos(e);
      this.startDraw(pos.x, pos.y);
    },
    onTouchMove(e) {
      const pos = this.getCanvasPos(e);
      this.moveDraw(pos.x, pos.y);
    },
    onTouchEnd(e) {
      this.endDraw();
    },

    // ===== 鼠标事件 =====
    onMouseDown(e) {
      const pos = this.getCanvasPos(e);
      this.startDraw(pos.x, pos.y);
    },
    onMouseMove(e) {
      const pos = this.getCanvasPos(e);
      this.moveDraw(pos.x, pos.y);
    },
    onMouseUp() {
      this.endDraw();
    },

    clearCanvas() {
      const canvas = this.$refs.signCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      this.drawPlaceholder(ctx);
      this.hasSigned = false;
    },
    canvasToBlob(canvas) {
      return new Promise((resolve) => {
        if (canvas.toBlob) {
          canvas.toBlob((blob) => resolve(blob), "image/png");
          return;
        }
        const dataURL = canvas.toDataURL("image/png");
        const binary = atob(dataURL.split(",")[1]);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i));
        }
        resolve(new Blob([new Uint8Array(array)], { type: "image/png" }));
      });
    },
    async handleConfirm() {
      if (!this.hasSigned) {
        Toast.fail("请先签名");
        return;
      }

      console.log("=== 开始签署上传 ===");
      console.log("activityId:", this.activityId);
      console.log("uploadType:", this.uploadType);
      console.log("babyId:", this.babyId);

      if (!this.activityId) {
        Toast.fail("缺少活动ID");
        return;
      }

      const uploadTypeValue = this.uploadType || (this.agreements[0] ? this.agreements[0].type : "");
      if (!uploadTypeValue) {
        Toast.fail("缺少协议类型参数");
        return;
      }

      const canvas = this.$refs.signCanvas;
      if (!canvas) {
        Toast.fail("画布未就绪");
        return;
      }

      this.uploading = true;

      try {
        const blob = await this.canvasToBlob(canvas);
        const currentAgreement = this.agreements[0] || {};
        const fileName = `signature-${currentAgreement.key || "sign"}-${Date.now()}.png`;
        const formData = new FormData();
        formData.append("file", blob, fileName);

        console.log("上传参数:", {
          activityId: this.activityId,
          type: uploadTypeValue,
          babyId: this.babyId || ""
        });

        const res = await uploadSign(formData, {
          activityId: this.activityId,
          type: uploadTypeValue,
          babyId: this.babyId || ""
        });

        console.log("上传响应:", res);

        if (res && res.success) {
          const responseData = res.data || {};
          const url = responseData.fileUrl || responseData.url || responseData.path || responseData;

          console.log("上传成功，返回链接:", url);

          if (!url) {
            Toast.fail("签署图片上传失败：无法获取返回链接");
            return;
          }

          this.showPopup = false;
          this.$emit("confirm", {
            url,
            agreements: this.agreements
          });
        } else {
          console.error("上传失败:", res);
          Toast.fail((res && res.message) || "签署图片上传失败");
        }
      } catch (error) {
        console.error("上传异常:", error);
        Toast.fail("签署图片上传异常：" + (error.message || "未知错误"));
      } finally {
        this.uploading = false;
      }
    },
    handleClose() {
      if (this.uploading) return;
      this.showPopup = false;
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.signature-popup {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;

  .signature-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border-bottom: 1px solid #eee;

    h3 {
      margin: 0;
      font-size: 16px;
      color: #333;
    }

    .van-icon {
      font-size: 20px;
      color: #999;
    }
  }

  .signature-body {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
  }

  .signature-target {
    padding: 12px;
    margin-bottom: 16px;
    background: #f7f7fa;
    border-radius: 6px;

    .target-label {
      font-size: 12px;
      color: #999;
      margin-bottom: 6px;
    }

    .target-names {
      font-size: 15px;
      color: #333;
      line-height: 22px;
      font-weight: 500;
    }
  }

  .signature-canvas-wrap {
    border: 1px dashed #ddd;
    border-radius: 8px;
    padding: 5px;
    background: #fafafa;

    .canvas-tip {
      text-align: center;
      font-size: 13px;
      color: #999;
      padding: 4px 0 2px;
    }

    .sign-canvas {
      display: block;
      width: 100%;
      height: 280px;
      background: #fff;
      border-radius: 4px;
      touch-action: none;   /* 禁止浏览器默认触摸行为 */
      cursor: crosshair;
    }

    .canvas-actions {
      display: flex;
      justify-content: flex-end;
      padding: 8px 2px 4px;
    }
  }

  .signature-footer {
    padding: 16px;
    border-top: 1px solid #eee;

    .van-button {
      border-radius: 22px;
      font-size: 16px;
    }
  }
}
</style>
